
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pillar]/almacenamiento-a-domicilio/[city]",
      function () {
        return require("private-next-pages/[pillar]/almacenamiento-a-domicilio/[city]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pillar]/almacenamiento-a-domicilio/[city]"])
      });
    }
  